import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ItemsService } from '../../../../services/items.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ElementRef } from '@angular/core';
import { ViewChild } from '@angular/core';
import Swal from 'sweetalert2';
import { DeviceDetectorService } from '../../../../services/device-detector.service';
import { HomeService } from '../../../../services/home.service';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { users } from '../../../../interfaces/users';
import { EmployeesService } from '../../../../services/employees';
import { ResigteringService } from '../../../Authentication/auth/resigtering.service';
import { UserService } from '../../../../services/user';
import { WarehouseTypeService } from '../../../../services/warehouse-type';

@Component({
  selector: 'app-addemployee',
  templateUrl: './addemployee.component.html',
  styleUrl: './addemployee.component.scss'
})
export class AddemployeeComponent {
  isSuperAdmin!: boolean;
  type: string = '7';

  accessPagesList = [
    { value: 0, label: 'employees' },
    { value: 1, label: 'financial' },
    { value: 2, label: 'myclients' },
    { value: 3, label: 'delivery' },
    { value: 4, label: 'supplies' },
    { value: 5, label: 'Orders' },
    { value: 6, label: 'Stock' },
    { value: 7, label: 'Pospage' }
  ];
  accessPages: number[] = [7];
  name!: string;
  job_title!: string;
  salary!: string;
  national_id!: string;
  phone!: string;
  address!: string;
  contentReady: boolean = false;
  employeeId!: string;
  hasToken: boolean = false;
  data!: FormGroup;
  selectedProductsDetails: users[] = [];
  productname: users[] = [];
  @ViewChild('fileInput', { static: false }) fileInput!: ElementRef;
  @ViewChild('mySelect') mySelect!: MatSelect;
  providers = new FormControl();
  filteredProviders: any[] = this.productname;
  selectedUsers!: any;
  itemData!: any;
  isUpdatePage = false;
  locationById: any;
  text: any;
  isMobile: boolean = false;
  isAr: boolean = false;
  createOrderByid!: any;
  users!: any;
  userLastNamesFromUrl: string[] = [];
  warehouses!: any;
  warehouseId!: any;
  formInfo!: FormGroup;
  systemAccess: boolean = false;
  isAdmin!: any;
  accountType!: any;
  isSubAdmin!: any; // New property to track system access
  submitted = false;
  constructor(
    private router: Router,
    private _homeService: HomeService,
    private _employee: EmployeesService,
    private fb: FormBuilder,
    private _ItemsService: ItemsService,
    private deviceService: DeviceDetectorService,
    private _ResigteringService: ResigteringService,
    private route: ActivatedRoute,
    public warehouseTypeService: WarehouseTypeService,
    private _userService: UserService,
  ) { }

  token = localStorage.getItem('token');
  ngOnInit() {
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem("language") == "ar";
    this.initiate();
    this.getWareHouses()
    this.warehouseId = localStorage.getItem("posId");
    this._userService.getAccountType().subscribe({
      next: (data) => {

        this.accountType = data['user_type'];
        this.isAdmin = this.accountType == "1" || this.accountType == "10";
        this.isSuperAdmin = this.accountType == "10";
        this.isSubAdmin = this.accountType == "6";
        this.updateWarehouseValidators();

      },
      error: (error) => console.error(error),
    });
    this.route.queryParams.subscribe(params => {
      if (params["id"] != null) {
        this.isUpdatePage = true;
        this.employeeId = params["id"];
        this.name = params["name"] || '';
        this.job_title = params["job_title"] || '';
        this.salary = params["salary"] || '';
        this.national_id = params["national_id"] || '';
        this.phone = params["phone"] || '';
        this.address = params["address"] || '';
        this.warehouseId = params["warehouse_id"] || null;
      }
    });

    this.formInfo = this.fb.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],
      phone: ['', [Validators.required, this.realEgyptOrKsaPhoneValidator]],
      systemAccess: [false]
    });
  }

  initiate() {
    this.data = this.fb.group({
      name: ['', Validators.required],
      job_title: ['', Validators.required],
      salary: ['', Validators.required],
      national_id: [''],
      phone: ['', [Validators.required, this.realEgyptOrKsaPhoneValidator]],
      address: [''],
      warehouse: [''],
      type: ['7', Validators.required],
    });
  }

  realEgyptOrKsaPhoneValidator = (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;

    const rawValue = String(control.value).trim();
    const arabicRegex = /[\u0600-\u06FF\u0660-\u0669\u06F0-\u06F9]/;
    if (arabicRegex.test(rawValue)) {
      return { arabicNotAllowed: true };
    }

    const phone = rawValue.replace(/[\s\-()]/g, '');
    const egyptMobileRegex = /^(01[0125]\d{8}|\+201[0125]\d{8}|00201[0125]\d{8})$/;
    const ksaMobileRegex = /^(05\d{8}|\+9665\d{8}|009665\d{8})$/;

    return egyptMobileRegex.test(phone) || ksaMobileRegex.test(phone)
      ? null
      : { invalidEgyptOrKsaPhone: true };
  };

  private updateWarehouseValidators(): void {
    const warehouseControl = this.data?.get('warehouse');
    if (!warehouseControl) return;

    if (this.isAdmin) {
      warehouseControl.setValidators([Validators.required]);
    } else {
      warehouseControl.clearValidators();
    }

    warehouseControl.updateValueAndValidity();
  }

  shouldShowError(controlName: string): boolean {
    const control = this.data?.get(controlName);
    return !!control && control.invalid && (control.touched || this.submitted);
  }

  getErrorMessage(controlName: string, label: string): string {
    const control = this.data?.get(controlName);

    if (!control || !control.errors) {
      return '';
    }

    if (control.errors['required']) {
      return this.isAr ? `${label} مطلوب` : `${label} is required`;
    }

    if (control.errors['invalidEgyptOrKsaPhone']) {
      return this.isAr
        ? `${label} لازم يكون رقم موبايل مصري أو سعودي صحيح`
        : `${label} must be a valid Egyptian or Saudi mobile number`;
    }

    if (control.errors['arabicNotAllowed']) {
      return this.isAr
        ? `${label} لازم يكون بأرقام إنجليزية بدون حروف عربية`
        : `${label} must use English digits without Arabic characters`;
    }

    return this.isAr ? `${label} غير صحيح` : `${label} is invalid`;
  }

  getMissingRequiredCount(): number {
    if (!this.data) {
      return 0;
    }

    return Object.keys(this.data.controls).filter((controlName) => {
      const control = this.data.get(controlName);
      return control?.hasError('required');
    }).length;
  }

  private validateBeforeSubmit(): boolean {
    this.submitted = true;

    if (this.data.invalid) {
      this.data.markAllAsTouched();

      Swal.fire({
        icon: 'warning',
        title: this.isAr ? 'تأكد من بيانات الموظف' : 'Please check employee data',
        text: this.isAr ? 'راجع الرسائل تحت الحقول المطلوبة أو غير الصحيحة' : 'Review the messages below the required or invalid fields',
        confirmButtonText: this.isAr ? 'تمام' : 'OK',
      });

      return false;
    }

    return true;
  }
  onCheckboxChange(event: any) {
    const value = +event.target.value;

    if (value === 7) return; // 🔒 ممنوع يتغير

    if (event.target.checked) {
      if (!this.accessPages.includes(value)) {
        this.accessPages.push(value);
      }
    } else {
      this.accessPages = this.accessPages.filter(v => v !== value);
    }
  }
  getWareHouses() {
    this._ItemsService.getWearHouses().subscribe({
      next: (res) => {
        this.warehouses = res.warehouse
      },
      error: (err) => {

      },
    });

  }

  dataForm: any;
  appendPostDtata() {
    this.dataForm = new FormData();
    this.dataForm.append('name', this.name);
    this.dataForm.append('job_title', this.job_title);
    this.dataForm.append('salary', this.salary);
    this.dataForm.append('national_id', this.national_id);
    this.dataForm.append('phone', this.phone);
    this.dataForm.append('address', this.address);
    this.dataForm.append('warehouse_id', this.warehouseId);
  }

  onSubmit() {
    if (!this.validateBeforeSubmit()) {
      return;
    }

    this.contentReady = true;
    this.appendPostDtata();
    if (this.isUpdatePage)
      this.onEdit();
    else
      this.makeTheEmployeeUser()
  }
  onAdd() {
    this._employee.createEmployee(this.dataForm).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم انشاء مواظف " : 'employee created',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;

        if (this.isMobile)
          this.router.navigateByUrl('/employeepage.mobile');
        this.router.navigateByUrl('/allemployees');
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل حفط المواظف" : 'employee not created',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });

        this.contentReady = false;

      },
    });
  }
  onEdit() {
    this._employee.editEmployee(this.dataForm, this.employeeId).subscribe({
      next: (res) => {
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم تعديل  المواظف" : 'employee edited',
          showConfirmButton: false,
          timer: 1500,
        });
        this.contentReady = false;

        if (this.isMobile)
          this.router.navigateByUrl('/employeepage.mobile');
        this.router.navigateByUrl('/allemployees');
      },
      error: (err) => {
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "فشل تعديل المواظف" : 'employee not edited',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });

        this.contentReady = false;

      },
    });
  }

  onProductSelected(event: MatSelectChange) {
    var selectedItems;
    if (event.value) {
      selectedItems = event.value;
    }
    else {

      selectedItems = event;
    }
    this.selectedUsers = selectedItems


    console.log(this.selectedUsers);
  }
  getAllUsers() {
    this.contentReady = true;

    this._homeService.getAllUsers().subscribe({
      next: (data) => {
        this.productname = data.sort((a: any, b: any) =>
          a.last_name.localeCompare(b.last_name, 'ar', { sensitivity: 'base' })
        );

        this.filteredProviders = this.productname;
        this.contentReady = false;
      },
      error: (error) => console.error(error),
    });
  }
  makeTheEmployeeUser() {
    const formData = new FormData();

    formData.append('first_name', this.name ?? '');
    formData.append('last_name', this.name ?? '');
    formData.append('instagram_link', '');
    formData.append('facebook_link', '');
    formData.append('tiktok_link', '');
    formData.append('username', this.phone ?? '');
    formData.append('password', this.phone ?? '');
    formData.append('password_confirmation', this.phone ?? '');
     formData.append('warehouse_id',  this.warehouseId);
    formData.append('phone', this.phone ?? '');
    formData.append('type', this.data.get('type')?.value ?? '7');

    this.accessPages.forEach((page: number, index: number) => {
      formData.append(`access_pages[${index}]`, page.toString());
    });

    this._ResigteringService.user_Resigter(formData).subscribe({
      next: (res) => {
        this.contentReady = false;
        Swal.fire({
          icon: 'success',
          title: this.isAr ? "تم انشاء الحساب" : 'user added successfully',
          showConfirmButton: false,
          timer: 1500,
        });
        this.onAdd();
        const redirectUrl = this.isMobile ? '/employeepage.mobile' : '/allemployees';
        this.router.navigateByUrl(redirectUrl);
      },
      error: (err) => {
        this.contentReady = false;
        Swal.fire({
          icon: 'error',
          title: this.isAr ? "  حصل مشكلة في انشاء المستخدم " : 'error while adding this user',
          text: this.isAr ? 'كلم الدعم' : 'you have to contact us',
          confirmButtonText: this.isAr ? 'تمام' : 'ok',
        });
      },
    });
  }
}
